import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { MayBe } from 'types/common';

import selfServicesApi from './service';
import { FlowType } from './types/SelfService';

type InitialState = {
  isFlowTypeModalOpen: boolean;
  flowType?: FlowType;
  isAdditionalCustomerDriving: MayBe<boolean>;
};

const initialState: InitialState = {
  flowType: undefined,
  isFlowTypeModalOpen: false,
  isAdditionalCustomerDriving: undefined,
};

const selfServicesSlice = createSlice({
  name: 'selfServices',
  initialState,
  reducers: {
    openFlowTypeModal: (state) => ({
      ...state,
      isFlowTypeModalOpen: true,
    }),
    resetFlowType: (state) => ({
      ...state,
      ...initialState,
    }),
    setIsAdditionalCustomerDriving: (state, { payload }: PayloadAction<boolean|undefined>) => ({
      ...state,
      isAdditionalCustomerDriving: payload,
    }),
    setFlowType: (state, { payload }) => ({
      ...state,
      flowType: payload,
      isFlowTypeModalOpen: false,
    }),
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      selfServicesApi.endpoints.getSelfServiceById.matchFulfilled,
      (state, action) => ({
        ...state,
        isAdditionalCustomerDriving: action.payload.isAdditionalCustomerDriving ?? state.isAdditionalCustomerDriving,
      }),
    );
  },
});

export default selfServicesSlice;
